import { useQuery } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import { notificationService } from '@/services/notification/notification.client';

import { GetHistoryAudit, GetHistoryAuditVariables } from '@/graphql/contracts/_generated_/getHistoryAudit.query';

import GetHistoryAuditQuery from '@/graphql/contracts/getHistoryAudit.query.gql';
import { EntityTypeEnum } from '@/graphql/contracts/_generated_/contracts';

export function useGetHistoryAuditData() {
  const { contractId }: { contractId: string } = useParams();
  const { data, loading, error, called } = useQuery<GetHistoryAudit, GetHistoryAuditVariables>(
    GetHistoryAuditQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      variables: {
        entityId: contractId,
        entityType: EntityTypeEnum.CONTRACT
      }
    },
  );

  return {
    auditHistoryData: data?.history ?? [],
    isLoadingAuditHistory: loading,
    auditHistoryError: error,
    isCalledAuditData: called
  } as const;
}